<template>
  <textarea :id="thisId">

  </textarea>
</template>

<script>
import '../css/layout.css'
/*
import 'tinymce/themes/modern/theme.js'
import 'tinymce/skins/lightgray/skin.min.css'
import 'tinymce/skins/lightgray/content.min.css'
import 'tinymce/plugins/advlist/plugin.js'
import 'tinymce/plugins/autolink/plugin.js'
*/
import Vue from 'vue'
	Vue.directive('tinymce-page',{ 
  	twoWay: true,
    inserted: function(el, binding, vnode) {
      var self = el
      var selec = el.id
      console.log("CI ARRIVO ")
      console.log(this)
      tinymce.init({
      	selector: '#'+el.id,
        setup: function(editor) {
        console.log("SETUP TINYMCE________")
        console.log(el.value)
        	// init tinymce
        	editor.on('init', function() {
            if(el.value!='')
                tinymce.get(el.id).setContent(el.value);
          });
          
          // when typing keyup event
          editor.on('keyup change', function(e) {
          	//console.log(el.id)
            // get new value
          	var new_value = tinymce.get(el.id).getContent();
            //console.log(new_value)
            // set model value
            el.value = new_value
            
            //console.log(el.value)
          });
          
        }
      });
    },
    unbind:function(){
      tinymce.remove()
    },
    update: function(newVal, oldVal) {
    	// set val and trigger eventdescrizione
    	//$(this.el).val(newVal).trigger('keyup');
      console.log(newVal)
    }
  
  })


export default {
  props: ['height','language','initvalue'],
  created () {
    console.log("TINYMCE CREATO");
    this.thisId="tinymce-"+this.$teras.random()
  },  
  mounted (){
      this.tinymceInit()
    
  },
  destroyed(){
    tinymce.remove()
  },
  watch: {
    '$teras.language':  'terasChange'
  },
  methods: {
    terasChange(){
      tinymce.remove()
      //tinymce.init({language : self.$teras.language})
      console.log("DA ABS" + this.$teras.language)
      //tinyMCE.execCommand(“mceRepaint”);
      var self = this
      tinyMCE.execCommand("mceRepaint")
      this.tinymceInit()
    },
    tinymceInit(){
        var self = this
        console.log("MOUNTED ABS-TINYMCE "+this.height)
        console.log(self.$el.id)
        console.log(self.$teras.language)
        console.log(document.styleSheets[2])
        //tinyMCE.baseURL = "https://cdn.tinymce.com/4"
        tinyMCE.baseURL = "/innsin/js/tinymce"
        this.tiny = tinymce.init({
            selector: '#'+self.$el.id,
            menubar: true,
            height: self.height,
            language : self.$teras.language,
            //language_url : '/201706/langs/it.js',
            content_css : "/innsin/css/layout.css",
            //content_css : document.styleSheets[0],
            //oninit : "setPlainText",
            entity_encoding : "raw",
            forced_root_block : false,
            valid_elements : 'p,a[*],li,ul,ol,div[*],span[*],img[*],sup,sub,br,strong/b,em,hr,h1,h2,h3,h4,h5,h6,table,tr,td,router-link[*]',

            relative_urls : false,
            //document_base_url: "http://cdn.tinymce.com/4",
            //importcss
            plugins: [
            'advlist autolink lists link image  paste  code',
            'charmap',
            'fullscreen',
            'contextmenu ',
            ''
            ],
            /*
            importcss_append: true,
            importcss_groups: [
    {title: 'Teras style', filter: /.yo-/}, // td.class and tr.class
    {title: 'Row style', filter: /.row/}, // td.class and tr.class
    {title: 'Col style', filter: /(.col|s)/}, // td.class and tr.class
    {title: 'Block styles', filter: /^(div|p)\./}, // div.class and p.class
    
  ],

            importcss_selector_filter: /\.yo-|\.col|\.s|\.row/,
            */
            'style_formats': [
    {title: 'Titolo h1 primary', block:'div', classes: 'title_h1 yo-color-primary'},
    {title: 'Titolo h1 secondary', block:'div', classes: 'title_h1 yo-color-secondary'},
    {title: 'Titolo h1 tertiary', block:'div', classes: 'title_h1 yo-color-tertiary'},
    {title: 'Pulsante', selector:'a', classes: 'site_button'},
    {title: 'Titolo', selector:'div', classes: 'title_h1 yo-color-secondary'}
],
            style_formats_autohide: true,
            style_formats_merge: true,
            contextmenu: "charmap | subscript  superscript | copy paste ",
            toolbar1: 'undo redo |  styleselect bold italic | subscript  superscript | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | charmap | fullscreen ',
            //toolbar1: 'undo redo |  styleselect | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
            //toolbar2: 'insert | print preview media | forecolor backcolor emoticons | codesample',

            setup: function(editor) {
            console.log("SETUP TINYMCE")
            console.log(self.$el.id)
                // init tinymce
                editor.on('init', function() {
                  //console.log(selfel.initValue)
                tinymce.get(self.$el.id).setContent(self.initvalue);

                var theEditor = tinymce.activeEditor
                //var wordCount = theEditor.plugins.wordcount.getCount()
                var new_value = tinymce.get(self.$el.id).getContent()
                self.$emit('input', new_value)
                //self.$emit('change', new_value, wordCount)
            });
            
            // when typing keyup event
            editor.on('keyup change', function(e) {
                
                var theEditor = tinymce.activeEditor
                //var wordCount = theEditor.plugins.wordcount.getCount()

                var new_value = tinymce.get(self.$el.id).getContent()
                /*self.$el.value = new_value */
                self.$emit('input', new_value)
                //self.$emit('change', new_value, wordCount)
                
                //console.log(new_value)
            });
            
            }
        })
        console.log(this.tiny)
        console.log("FINITA")
      }
  }
  
}

</script>
<style>

</style>
